"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _flow = _interopRequireDefault(require("lodash/fp/flow"));

var _countBy = _interopRequireDefault(require("lodash/fp/countBy"));

var _identity = _interopRequireDefault(require("lodash/fp/identity"));

var _pickBy = _interopRequireDefault(require("lodash/fp/pickBy"));

var _keys = _interopRequireDefault(require("lodash/fp/keys"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _flow.default)((0, _countBy.default)(_identity.default), (0, _pickBy.default)(function (it) {
  return it > 1;
}), _keys.default);

exports.default = _default;
//# sourceMappingURL=index.js.map